const success = () => import("@/pages/success")

export default {
	routes: [{ path: "/success", component: success, name: "success", meta: { title: "成功" } }]
}
